export const authConfig = {
  PCAS_CONNECTOR: 'pcas',
  TWCAS_CONNECTOR: 'twcas',
  PCAS_XSRF_COOKIE_NAME: 'pcas_csrf_token',
  TWCAS_XSRF_COOKIE_NAME: 'twcas_csrf_token',
};

export const LAYOUT_LEVELS = {
  module: 'module',
  item: 'item',
};

export default authConfig;
